<template>
    <div class="step-source">
        <h3>1. Source du classement</h3>
        <div class="source-cards">
            <button type="button" class="source-card" @click="$emit('select', 'manual')">
                <span class="source-icon">⌨️</span>
                <span class="source-title">Saisie manuelle</span>
                <span class="source-desc">Coller une liste de noms ordonnée (tableau et/ou poules).</span>
            </button>
            <button type="button" class="source-card" @click="$emit('select', 'excel')">
                <span class="source-icon">📊</span>
                <span class="source-title">Fichier Excel</span>
                <span class="source-desc">Gabarit Catégorie / Joueur / Code CLT.</span>
            </button>
            <button type="button" class="source-card" @click="$emit('select', 'dartup')">
                <span class="source-icon">📥</span>
                <span class="source-title">Dartup</span>
                <span class="source-desc">Lien des résultats Dartup (tous les tableaux d'un coup) ou export xlsx.</span>
            </button>
            <button type="button" class="source-card" @click="$emit('select', 'd4w')">
                <span class="source-icon">🗄️</span>
                <span class="source-title">Darts4Windows</span>
                <span class="source-desc">Base de la journée (.dfw) : tous les tableaux et poules d'un coup.</span>
            </button>
            <button type="button" class="source-card" @click="$emit('select', 'dartconnect')">
                <span class="source-icon">🎯</span>
                <span class="source-title">DartConnect</span>
                <span class="source-desc">Import automatique depuis un lien de résultats DartConnect.</span>
            </button>
            <button type="button" class="source-card" @click="$emit('select', '3kdarts')">
                <span class="source-icon">🏹</span>
                <span class="source-title">3K Darts</span>
                <span class="source-desc">Lien d'une épreuve ou d'une liste de tournois 3K Darts (poules comprises).</span>
            </button>
            <button
                v-if="allowFederal"
                type="button"
                class="source-card"
                @click="$emit('select', 'federal_pdf')"
            >
                <span class="source-icon">📄</span>
                <span class="source-title">PDF fédéral (FFD)</span>
                <span class="source-desc">Classement national officiel, plusieurs tournois en un fichier.</span>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { SourceKind } from './types'

// Le fédéral (national) n'appartient à aucun comité/ligue -- réservé au super_admin,
// cf. ImportClassement.vue et check_import_scope_access côté serveur.
defineProps<{ allowFederal: boolean }>()
defineEmits<{ select: [source: SourceKind] }>()
</script>

<style scoped>
.step-source h3 {
    margin-bottom: 1rem;
}

.source-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
}

.source-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    padding: 1.25rem;
    border: 1px solid var(--color-light-shadow, #ddd);
    border-radius: var(--radius, 8px);
    background: var(--color-bg, #fff);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.source-card:hover {
    border-color: var(--color-accent, #1a3a5c);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.source-icon {
    font-size: 1.6rem;
}

.source-title {
    font-weight: 700;
}

.source-desc {
    font-size: 0.85rem;
    color: var(--color-fg-muted, #888);
}
</style>
